<template>
    <div class="">
        <Wait_Skeleton v-if="!IsWait" />

        <Card class=" h-100" v-if="IsWait">
            <template #title> Urun Düzenle</template>
            <template #content>

                <div class="grid flex justify-content-center flex-wrap">
                    <div class="col-7">

                        <IslemYapiliyor v-if="IslemYapiliyor" />

                        <div class="grid">
                            <!-- 1. Kolon -->
                            <div class="col-6">
                                <div class="grid">
                                    <div class="col-12">
                                        <label for="Ad" class="font-bold block">Urun Ad</label>
                                        <InputText id="Ad" type="text" v-model="Ad" :invalid="this.Valid.Ad"
                                            class="text-base text-color w-full" />
                                    </div>
                                    <div class="col-12">


                                    </div>
                                    <div class="col-12 mt-5">
                                        <div class="flex items-center">
                                            <label for="PasifMi" class="font-bold block mr-2">PasifMi</label>
                                            <Checkbox id="PasifMi" v-model="PasifMi" :binary="true" />
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <!-- 2. Kolon -->
                            <div class="col-6">
                                <div class="grid">
                                    <div class="col-12">
                                        <label for="Karakteristik" class="font-bold block">Karakteristik</label>
                                        <Select v-model="Karakteristik" :options="KarakteristikListesi" optionLabel="Ad"
                                            filter :invalid="this.Valid.Karakteristik" optionValue="Karakteristik_rowid"
                                            placeholder="Seçin" class="text-base text-color w-full" />
                                    </div>
                                    <div class="col-12">
                                        <label for="Kategori" class="font-bold block">Kategori</label>
                                        <Select v-model="Kategori" :options="KategoriListesi" optionLabel="Ad" filter
                                            :invalid="this.Valid.Kategori" optionValue="Kategori_rowid"
                                            placeholder="Seçin" class="text-base text-color w-full" />
                                    </div>
                                    <div class="col-12">
                                        <label for="AltKategori" class="font-bold block">AltKategori</label>
                                        <Select v-model="AltKategori" :options="AltKategoriListesi" optionLabel="Ad"
                                            filter :invalid="this.Valid.AltKategori" optionValue="AltKategori_rowid"
                                            placeholder="Seçin" class="text-base text-color w-full" />
                                    </div>
                                </div>
                            </div>
                            <div class="col-12">
                                <label for="Aciklama" class="font-bold block"> Açıklama</label>
                                <Textarea id="Aciklama" v-model="Aciklama" rows="2" cols="30"
                                    class="text-base text-color w-full" />
                            </div>
                        </div>

                        <div class="col-12 flex justify-content-end flex-wrap">
                            <Button class="m-1" label="Tamam" icon="pi pi-check" iconPos="right" size="small"
                                severity="success" @click="this.handleClick()" autofocus :disabled="IslemYapiliyor"
                                v-if="!IslemYapiliyor" />
                        </div>

                    </div>
                </div>

            </template>
        </Card>
    </div>
</template>

<script>
import GlobalServis from "../../../../../services/GlobalServis";

export default {
    data() {
        return {
            IslemYapiliyor: false,
            IsWait: false,
            responsiveOptions: [
                { breakpoint: '1024px', numVisible: 5 },
                { breakpoint: '768px', numVisible: 3 },
                { breakpoint: '560px', numVisible: 1 }
            ],
            //
            Urun_rowid: "",
            Ad: "",
            PasifMi: false,
            Karakteristik: 0,
            Kategori: 0,
            AltKategori: 0,
            Aciklama: "",
            //
            KarakteristikListesi: [],
            KategoriListesi: [],
            AltKategoriListesi: [],

            // Validation Elements
            Valid: {
                Ad: false,
                PasifMi: false,
                Karakteristik: false,
                Kategori: false,
                AltKategori: false,
                Aciklama: false,
            }
        }
    },
    methods: {
        handleClick() {
            if (this._FormCheck()) { return; }
            this.IslemYapiliyor = true;

            let data = {
                Urun_rowid: this.Urun_rowid,
                Ad: this.Ad,
                PasifMi: this.PasifMi,
                pKarakteristik: this.Karakteristik,
                pKategori: this.Kategori,
                pAltKategori: this.AltKategori,
                Aciklama: this.Aciklama,
            };

            GlobalServis.GlobalServis("POST", "UpdateUrun", data).then((res) => {
                if (res.status == 200) {
                    this.$toast.add({
                        severity: "success",
                        summary: "Başarılı",
                        detail: "Urun düzenlenmiştir.",
                        life: 3000,
                    });
                    this._ResetForm();
                } else if (res.response.status === 999) {
                    this.$toast.add({
                        severity: "warn",
                        summary: "Uyarı",
                        detail: res.response.data,
                        life: 3000,
                    });
                } else {
                    this.$toast.add({
                        severity: "error",
                        summary: "Hata",
                        detail: "Hata oldu",
                        life: 3000,
                    });
                }
            }).then(() => {
                this.IslemYapiliyor = false;
            });
        },
        _GetUrunInfoServis() {
            let data = {
                Urun_rowid: this.$route.query.UrunNo,
            };
            GlobalServis.GlobalServis("POST", "GetUrunInfo", data).then((res) => {
                if (res.status == 200) {
                    this.Urun_rowid = this.$route.query.UrunNo;
                    this.Ad = res.data[0].Ad;
                    this.PasifMi = res.data[0].PasifMi;
                    this.Karakteristik = res.data[0].pKarakteristik;
                    this.Kategori = res.data[0].pKategori;
                    this.AltKategori = res.data[0].pAltKategori;
                    this.Aciklama = res.data[0].Aciklama;
                    //
                    this.IsWait = true;
                } else if (res.status == 400) {
                    this.$toast.add({
                        severity: "error",
                        summary: "Hata",
                        detail: "Önemli bir hata meydana geldi",
                        life: 3000,
                    });
                } else {
                    this.$toast.add({
                        severity: "error",
                        summary: "Hata",
                        detail: "Bilinmeyen bir hata meydana geldi",
                        life: 3000,
                    });
                }
            });
        },
        _GetKarakteristikListesi() {
            GlobalServis.GlobalServis("GET", "GetKarakteristik_Sade", "").then((res) => {
                if (res.status == 200) {
                    this.KarakteristikListesi = res.data;
                } else if (res.status == 400) {
                    this.$toast.add({
                        severity: "error",
                        summary: "Hata",
                        detail: "Önemli bir hata meydana geldi",
                        life: 3000,
                    });
                } else {
                    this.$toast.add({
                        severity: "error",
                        summary: "Hata",
                        detail: "Bilinmeyen bir hata meydana geldi",
                        life: 3000,
                    });
                }
            });
        },
        _GetKategoriListesi() {
            GlobalServis.GlobalServis("GET", "GetKategori_Sade", "").then((res) => {
                if (res.status == 200) {
                    this.KategoriListesi = res.data;
                } else if (res.status == 400) {
                    this.$toast.add({
                        severity: "error",
                        summary: "Hata",
                        detail: "Önemli bir hata meydana geldi",
                        life: 3000,
                    });
                } else {
                    this.$toast.add({
                        severity: "error",
                        summary: "Hata",
                        detail: "Bilinmeyen bir hata meydana geldi",
                        life: 3000,
                    });
                }
            });
        },
        _GetAltKategoriListesi() {
            GlobalServis.GlobalServis("GET", "GetAltKategori_Sade", "").then((res) => {
                if (res.status == 200) {
                    this.AltKategoriListesi = res.data;
                } else if (res.status == 400) {
                    this.$toast.add({
                        severity: "error",
                        summary: "Hata",
                        detail: "Önemli bir hata meydana geldi",
                        life: 3000,
                    });
                } else {
                    this.$toast.add({
                        severity: "error",
                        summary: "Hata",
                        detail: "Bilinmeyen bir hata meydana geldi",
                        life: 3000,
                    });
                }
            });
        },
        _ResetForm() {
            this.Ad = "";
            this.PasifMi = false;
            this.Karakteristik = "";
            this.Kategori = "";
            this.AltKategori = "";
            this.Aciklama = "";
            //
            this.KarakteristikListesi = [];
            this.KategoriListesi = [];
            this.AltKategoriListesi = [];

        },
        _FormCheck() {
            let Check = false;
            if (this.Ad === "") {
                this.Valid.Ad = true;
                this.$toast.add({ severity: "warn", summary: "Uyarı", detail: "Ad girin", life: 3000, });
                Check = true;
                return Check;
            } else { this.Valid.Ad = false; Check = false; }

            if (this.Karakteristik === 0) {
                this.Valid.Karakteristik = true;
                this.$toast.add({ severity: "warn", summary: "Uyarı", detail: "Karakteristik seçin", life: 3000, });
                Check = true;
                return Check;
            } else { this.Valid.Karakteristik = false; Check = false; }

            if (this.Kategori === 0) {
                this.Valid.Kategori = true;
                this.$toast.add({ severity: "warn", summary: "Uyarı", detail: "Kategori seçin", life: 3000, });
                Check = true;
                return Check;
            } else { this.Valid.Kategori = false; Check = false; }

            if (this.AltKategori === 0) {
                this.Valid.AltKategori = true;
                this.$toast.add({ severity: "warn", summary: "Uyarı", detail: "Alt kategori seçin", life: 3000, });
                Check = true;
                return Check;
            } else { this.Valid.Kategori = false; Check = false; }

            return Check;
        },
    },
    mounted() {
        this._GetUrunInfoServis();
        this._GetKarakteristikListesi();
        this._GetKategoriListesi();
        this._GetAltKategoriListesi();
    },
    components: {
    },
}
</script>
<style scoped></style>